import { action } from 'satcheljs';
import NudgedRow from '../store/schema/NudgedRow';

export const onGetNudgesCompleted = action(
    'ON_GET_NUDGES_COMPLETED',
    (nudgedRows: NudgedRow[]) => ({
        nudgedRows,
    })
);
